import { Component, Vue } from 'vue-property-decorator';
import { PreferredContactMethodType } from '@/constants/preferred-contact-method-type';

@Component({
  computed: {
    showPhoneMethod(): boolean {
      return (
        this.$data.selectedMethodOfContact === PreferredContactMethodType.Call
      );
    },
    showPhoneField(): boolean {
      return (
        this.$data.selectedMethodOfContact ===
          PreferredContactMethodType.Text ||
        this.$data.selectedMethodOfContact === PreferredContactMethodType.Call
      );
    },
    showAddressFields(): boolean {
      return (
        this.$data.selectedMethodOfContact ===
        PreferredContactMethodType.Address
      );
    },
    showWebsiteField(): boolean {
      return (
        this.$data.selectedMethodOfContact ===
        PreferredContactMethodType.Website
      );
    }
  }
})
export default class CustomerShowFieldMixin extends Vue {
  public selectedMethodOfContact = '';
}
